export default Object.freeze({ DMM: 'dmm' });
